'use client';

import { Minus, Plus } from '@modules/common/icons';
import CountBadge from './count-badge';

type CategoryHeaderProps = {
  label: string;
  cookieCount: number;
  hasProviders: boolean;
  isExpanded: boolean;
  onToggle: () => void;
};

const CategoryHeader = ({
  label,
  cookieCount,
  hasProviders,
  isExpanded,
  onToggle,
}: CategoryHeaderProps) => {
  if (!hasProviders) {
    return (
      <div className="flex items-center gap-2">
        <Plus size="16" className="shrink-0 text-brand-neutral-900" />
        <span className="font-body font-semibold text-sm leading-[1.5] text-brand-neutral-900">
          {label}
        </span>
      </div>
    );
  }

  const Icon = isExpanded ? Minus : Plus;
  const action = isExpanded ? 'Collapse' : 'Expand';

  return (
    <button
      type="button"
      onClick={onToggle}
      aria-expanded={isExpanded}
      aria-label={`${action} ${label}`}
      className="flex cursor-pointer items-center gap-2 text-left"
    >
      <Icon size="16" className="shrink-0 text-brand-neutral-900" />
      <span className="font-body font-semibold text-sm leading-[1.5] text-brand-neutral-900">
        {label}
      </span>
      <CountBadge count={cookieCount} />
    </button>
  );
};

export default CategoryHeader;
